import { render, staticRenderFns } from "./handle.vue?vue&type=template&id=14263529&scoped=true"
import script from "./handle.vue?vue&type=script&lang=js"
export * from "./handle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14263529",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14263529')) {
      api.createRecord('14263529', component.options)
    } else {
      api.reload('14263529', component.options)
    }
    module.hot.accept("./handle.vue?vue&type=template&id=14263529&scoped=true", function () {
      api.rerender('14263529', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/sendDriverInvitationCode/component/handle.vue"
export default component.exports